module.exports = __webpack_public_path__ + "media/images/illustration-05-c6f32cf62b8bf7d4f87645061748e242.jpg";